import { Box, type BoxProps, Container, type ContainerProps } from '@chakra-ui/react'
import type { ReactElement } from 'react'

export type SectionProps = {
  bg?: BoxProps['bg']
  py?: BoxProps['py']
  px?: BoxProps['px']
  maxWidth?: BoxProps['maxWidth']
  coverViewport?: boolean
  centerContent?: ContainerProps['centerContent']
  borderRadius?: BoxProps['borderRadius']
  bgComponent?: ReactElement | null
}

export default function Section({
  children,
  bg,
  py,
  px,
  maxWidth,
  centerContent,
  borderRadius,
  coverViewport = false,
  bgComponent = null,
}: {
  children: React.ReactNode
} & SectionProps): JSX.Element {
  return (
    <Box
      bg={bg}
      py={py}
      px={px}
      width="100%"
      minHeight={coverViewport ? '100vh' : undefined}
      borderRadius={borderRadius}
      position="relative"
    >
      {bgComponent != null ? (
        <Box
          width={`calc(100% - 2 * ${px ?? '0px'})`}
          height={`calc(100% - 2 * ${py ?? '0px'})`}
          position="absolute"
          overflow="visible"
        >
          {bgComponent}
        </Box>
      ) : null}
      <Container maxWidth={maxWidth} centerContent={centerContent} position="relative">
        {children}
      </Container>
    </Box>
  )
}
